import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import axios from 'axios';
import { Bar } from 'react-chartjs-2';
import Grid from '@material-ui/core/Grid';
const baseUrl = 'https://api.e-stat.go.jp/rest/2.1/app/json/getStatsData?';
const apiKey = process.env.REACT_APP_JPN_STAT_API_KEY;
const params = 'lang=J&statsDataId=0003286070&metaGetFlg=Y&cntGetFlg=N&sectionHeaderFlg=1';
const bgRed = 'rgba(255, 99, 132, 0.8)';
const bgBlue = 'rgba(54, 162, 235, 0.8)';
const bgGreen = 'rgba(41, 241, 195, 0.8)';
const borderRed = 'rgba(255,99,132,1)';
const borderBlue = 'rgba(54, 162, 235, 1)';
const borderGreen = 'rgba(41, 241, 195, 1)';
let total = '';
const App = () => {
	const [ dataDetailList, setDataDetailList ] = useState([]);
	const [ dataNameList, setDataNameList ] = useState([]);
	const [ dataChart, setDataChart ] = useState({});
	const useAPI = (endpoint) => {
		useEffect(() => {
			getData();
		}, []);

		const getData = async () => {
			const response = await fetch(endpoint);
			const data = await response.json();
			setDataDetailList(data.GET_STATS_DATA.STATISTICAL_DATA.DATA_INF.VALUE);
			setDataNameList(data.GET_STATS_DATA.STATISTICAL_DATA.CLASS_INF.CLASS_OBJ[2].CLASS);
		};
	};
	useAPI(`${baseUrl}appId=${apiKey}&${params}`);

	useEffect(
		() => {
			let dataSets = {};
			let dataEachYears = {};
			let dataName = {};
			dataDetailList.map((data) => {
				dataEachYears[data['@time'].substr(0, 4)] = [];
			});
			dataNameList.map((c) => (dataName[c['@code']] = c['@name']));
			dataDetailList.map((data) => {
				if (data['@cat01'] == '100' && data['@cat02'] == '320' && data['@cat04'] == '100') {
					let hash = {};
					if (parseInt(data['@cat03']) < 270) {
						//only each gadget (I removed all grouped category)
						hash[dataName[data['@cat03']]] = data['$'];
						dataEachYears[data['@time'].substr(0, 4)].push(hash);
					}
				}
			});

			let gadgetList = [];
			let gadgetTotalPercent = [];
			for (let dataAYear in dataEachYears) {
				gadgetList = [];
				gadgetTotalPercent = [];
				dataEachYears[dataAYear].map((eachGadgetData) => {
					for (let gadget in eachGadgetData) {
						if (gadget !== '総数') {
							gadgetList.push(gadget);
							gadgetTotalPercent.push(eachGadgetData[gadget]);
						} else {
							total = eachGadgetData[gadget];
						}
					}
				});
				dataSets[dataAYear] = gadgetTotalPercent;
			}
			let list = [];
			for (let year in dataSets) {
				list.push({
					label: year,
					borderColor:
						year === '2014' ? borderBlue : year === '2015' ? borderRed : year === '2016' ? borderGreen : '',
					borderWidth: 1,
					backgroundColor:
						year === '2014' ? bgBlue : year === '2015' ? bgRed : year === '2016' ? bgGreen : '',
					data: dataSets[year]
				});
			}

			setDataChart({
				labels: gadgetList, //x軸ラベル
				datasets: list
			});
		},
		[ dataDetailList, dataNameList ]
	);

	const options = {
		tooltips: {
			callbacks: {
				label: (item) => `${item.yLabel} %`
			}
		},
		scales: {
			yAxes: [
				{
					scaleLabel: {
						display: true,
						labelString: '%'
					}
				}
			]
		},
		title: {
			display: true, //グラフのタイトル表示
			text: `青少年のインターネット利用環境実態調査 / 総数${total} /調査方法〔訪問・ＷＥＢ・郵送〕` //グラフのタイトルは改行もできる
		}
	};
	return (
		<div className="p-5">
			<Grid container spacing={3}>
				<Grid item sm={12} md={6}>
					<Bar data={dataChart} options={options} />
				</Grid>
			</Grid>
		</div>
	);
};
export default App;
